const core = {
  // ==================== COMMON ====================
  'common.save': 'Speichern',
  'common.saving': 'Speichern...',
  'common.cancel': 'Abbrechen',
  'common.delete': 'Löschen',
  'common.edit': 'Bearbeiten',
  'common.back': 'Zurück',
  'common.close': 'Schließen',
  'common.search': 'Suchen',
  'common.loading': 'Laden...',
  'common.error': 'Fehler',
  'common.success': 'Erfolg',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.confirm': 'Bestätigen',
  'common.create': 'Erstellen',
  'common.update': 'Aktualisieren',
  'common.refresh': 'Aktualisieren',
  'common.add': 'Hinzufügen',
  'common.remove': 'Entfernen',
  'common.active': 'Aktiv',
  'common.inactive': 'Inaktiv',
  'common.unlimited': 'Unbegrenzt',
  'common.all': 'Alle',
  'common.none': 'Keine',
  'common.actions': 'Aktionen',
  'common.or': 'oder',
  'common.copy': 'Kopieren',
  'common.pleaseWait': 'Bitte warten Sie einen Moment',
  'common.noDescription': 'Keine Beschreibung',
  'common.username': 'Benutzername',
  'common.password': 'Passwort',
  'common.email': 'E-Mail',
  'common.description': 'Beschreibung',
  'common.name': 'Name',
  'common.status': 'Status',
  'common.category': 'Kategorie',
  'common.price': 'Preis',
  'common.currency': 'Währung',
  'common.quantity': 'Menge',
  'common.unit': 'Einheit',
  'common.total': 'Gesamt',
  'common.per': 'pro',
  'common.noCategory': 'Ohne Kategorie',
  'common.stock': 'Lager',
  'common.decrease': 'minus',
  'common.increase': 'plus',

  // ==================== LOGIN ====================
  'login.title': 'Anmelden',
  'login.subtitle': 'Melden Sie sich an, um Ihre Beschaffungen zu verwalten.',
  'login.username': 'Benutzername',
  'login.password': 'Passwort',
  'login.submit': 'Anmelden',
  'login.submitting': 'Anmelden...',
  'login.ssoFailed': 'Anmeldung über Gineex Central fehlgeschlagen. Bitte erneut aus Gineex Central öffnen.',
  'login.fillAllFields': 'Bitte füllen Sie alle Felder aus.',
  'login.checkingSession': 'Session wird überprüft...',

  // ==================== ZWEI-FAKTOR-ANMELDUNG ====================
  'login.mfa.codeLabel': 'Code aus der Authenticator-App',
  'login.mfa.recoveryLabel': 'Wiederherstellungscode',
  'login.mfa.codeHint': 'Öffnen Sie Ihre Authenticator-App und geben Sie den 6-stelligen Code ein.',
  'login.mfa.recoveryHint': 'Jeder Wiederherstellungscode kann nur einmal verwendet werden.',
  'login.mfa.enterCode': 'Bitte Code eingeben.',
  'login.mfa.enterRecovery': 'Bitte Wiederherstellungscode eingeben.',
  'login.mfa.confirm': 'Bestätigen',
  'login.mfa.useRecovery': 'Wiederherstellungscode verwenden',
  'login.mfa.useApp': 'Code aus der App verwenden',
  'login.mfa.back': 'Zurück',
  'login.mfa.expired': 'Die Anmeldung ist abgelaufen. Bitte erneut anmelden.',
  'login.mfa.invalidCode': 'Code ungültig',
  'login.mfa.locked': 'Zu viele Fehlversuche. Bitte in 15 Minuten erneut versuchen.',
  'login.mfa.networkError': 'Verbindungsfehler: Kann nicht mit dem Server verbinden.',
  'login.mfa.failed': 'Anmeldung fehlgeschlagen.',
  'login.mfa.setupTitle': 'Zwei-Faktor-Anmeldung einrichten',
  'login.mfa.setupHint': 'Scannen Sie den QR-Code mit einer Authenticator-App (z. B. Microsoft oder Google Authenticator) und geben Sie anschließend den angezeigten 6-stelligen Code ein.',
  'login.mfa.qrAlt': 'QR-Code für die Authenticator-App',
  'login.mfa.manualHint': 'Kein Scan möglich? Geheimnis von Hand eingeben:',
  'login.mfa.finishSetup': 'Einrichtung abschließen',
  'login.mfa.codesTitle': 'Wiederherstellungscodes',
  'login.mfa.codesHint': 'Bewahren Sie diese Codes sicher auf. Ohne Authenticator-App melden Sie sich mit einem Code an – jeder Code gilt nur einmal. Die Codes werden nur jetzt angezeigt.',
  'login.mfa.copyCodes': 'Codes kopieren',
  'login.mfa.codesCopied': 'Codes kopiert',
  'login.mfa.copyFailed': 'Kopieren nicht möglich. Bitte die Codes abschreiben.',
  'login.mfa.codesStored': 'Ich habe die Codes sicher aufbewahrt',
  'login.mfa.continue': 'Weiter',
  'admin.mfa.enabled': '2FA: eingerichtet',
  'admin.mfa.disabled': '2FA: nicht eingerichtet',
  'admin.mfa.viaCentral': '2FA: über Gineex Central',
  'admin.mfa.reset': '2FA zurücksetzen',
  'admin.mfa.resetConfirm': '2FA für „{username}" zurücksetzen? Der Benutzer wird abgemeldet und muss die Zwei-Faktor-Anmeldung beim nächsten Login neu einrichten.',
  'admin.mfa.resetDone': '2FA für „{username}" zurückgesetzt.',
  'admin.mfa.resetError': '2FA konnte nicht zurückgesetzt werden.',
  'admin.mfa.requiredTitle': 'Zwei-Faktor-Anmeldung für alle Benutzer verpflichtend',
  'admin.mfa.requiredHint': 'Wenn aktiv, richtet jeder Benutzer beim nächsten Login eine Authenticator-App ein und meldet sich danach mit Passwort und 6-stelligem Code an. Wirksam nach dem Speichern. Benutzer, die die Zwei-Faktor-Anmeldung bereits eingerichtet haben, behalten sie auch nach dem Ausschalten (zurücksetzen unter „Benutzer“).',

  // ==================== HEADER ====================
  'header.administrator': 'Administrator',
  'header.supervisor': 'Supervisor',
  'header.purchaser': 'Purchaser',
  'header.gineexSupport': 'Gineex Support',
  'users.centralManaged': 'Konto wird über Gineex Central verwaltet',
  'users.viaCentral': 'über Gineex Central',
  'header.home': 'Zurück zur Startseite',
  'header.backToCatalogs': 'Zurück zur Katalog-Übersicht',
  'header.newBanf': 'Neue BANF erstellen',
  'header.banfRequests': 'BANF-Anfragen',
  'header.banfRequestsDrafts': 'BANF-Anfragen ({drafts} Entwürfe, {pending} ausstehend)',
  'header.myBanfRequests': 'Meine BANF-Anfragen ({count} ausstehend)',
  'header.banfRequestsCostCenter': 'BANF-Anfragen Kostenstelle {costCenter} ({count} ausstehend)',
  'header.banfRequestsAll': 'BANF-Anfragen ({count} ausstehend)',
  'header.adminArea': 'Admin-Bereich',
  'header.settings': 'Einstellungen',
  'header.cart': 'Warenkorb ({count} Artikel)',
  'header.logout': 'Abmelden',
  'header.backToSap': 'Zurück zu SAP',
  'header.lightMode': 'Light Mode aktivieren',
  'header.darkMode': 'Dark Mode aktivieren',
  'header.reloadPage': 'Seite neu laden',
  'header.portalLogoAlt': 'Portal Logo',

  // ==================== FOOTER ====================
  'footer.allRightsReserved': 'Alle Rechte vorbehalten.',
  'footer.madeWith': 'Made with',
  'footer.inGermany': 'in Germany',
  'footer.version': 'Version',

  // ==================== HOME PAGE ====================
  'home.welcome': 'Willkommen, {name}',
  'home.selectModule': 'Wählen Sie ein Modul aus, um zu beginnen',
  'home.procurement': 'Beschaffung',
  'home.procurementDesc': 'Bestellanforderungen erstellen, Kataloge durchsuchen und Warenkörbe verwalten',
  'home.warehouse': 'Lagerverwaltung',
  'home.warehouseDesc': 'Lagermaterial suchen, Bestand einsehen und BANF erstellen',
  'home.einvoicing': 'E-Invoicing',
  'home.einvoicingDesc': 'Ein- und Ausgangsrechnungen per OCR erfassen, KI-gestützt auf Plausibilität prüfen und mit Bestellungen abgleichen',
  'home.einvoicingBadge': 'ZUGFeRD · KSeF u. v. m. konform',
  'home.plantMaintenance': 'Plant Maintenance',
  'home.plantMaintenanceDesc': 'Instandhaltungsaufträge, Wartungspläne und technische Objekte verwalten',
  'home.materialEntry': 'Material-Schnellerfassung',
  'home.materialEntryDesc': 'Materialstammdaten mit reduzierten Feldern schnell erfassen und an SAP übermitteln',
  'home.orderConfirmation': 'Auftragsbestätigung erfassen',
  'home.orderConfirmationDesc': 'Lieferanten-AB per OCR erfassen und KI-gestützt gegen die MM-Bestellung prüfen',
  'home.workflowEditor': 'Workflow Editor',
  'home.workflowEditorDesc': 'Genehmigungsprozesse definieren und mit anderen Modulen verbinden',
  'home.moreModules': 'Weitere Module',
  'home.moreModulesDesc': 'Zusätzliche Module werden in zukünftigen Updates hinzugefügt',
  'home.comingSoon': 'Demnächst verfügbar',
  'home.moduleLocked': 'Modul nicht lizenziert',
  'home.userFallback': 'Benutzer',

  // ==================== LOGOUT MODAL ====================
  'logout.titleSap': 'Zurück zu SAP',
  'logout.titleLogout': 'Abmelden',
  'logout.confirmSap': 'Möchten Sie wirklich zurück zu SAP wechseln?',
  'logout.confirmLogout': 'Möchten Sie sich wirklich abmelden?',
  'logout.cancel': 'Abbrechen',
  'logout.toSap': 'Zu SAP',
  'logout.submit': 'Abmelden',

  // ==================== SETTINGS VIEW ====================
  'settings.title': 'Benutzer-Einstellungen',
  'settings.profile': 'Profil',
  'settings.security': 'Sicherheit',
  'settings.changePassword': 'Passwort ändern',
  'settings.firstName': 'Vorname',
  'settings.lastName': 'Nachname',
  'settings.username': 'Benutzername',
  'settings.email': 'E-Mail-Adresse',
  'settings.sapUser': 'SAP-Benutzer',
  'settings.requester': 'Anforderer',
  'settings.department': 'Abteilung',
  'settings.costCenter': 'Kostenstelle',
  'settings.plant': 'Werk',
  'settings.purchasingOrg': 'Einkäuferorganisation',
  'settings.purchasingGroup': 'Einkäufergruppe',
  'settings.editProfile': 'Profil bearbeiten',
  'settings.saveChanges': 'Änderungen speichern',
  'settings.cancelEdit': 'Abbrechen',
  'settings.profileSaved': 'Profil erfolgreich gespeichert!',
  'settings.profileError': 'Fehler beim Speichern des Profils',
  'settings.currentPassword': 'Aktuelles Passwort',
  'settings.newPassword': 'Neues Passwort',
  'settings.confirmPassword': 'Passwort bestätigen',
  'settings.passwordMismatch': 'Neue Passwörter stimmen nicht überein',
  'settings.passwordMinLength': 'Das neue Passwort muss mindestens 6 Zeichen lang sein',
  'settings.passwordRequired': 'Bitte geben Sie Ihr aktuelles Passwort ein',
  'settings.passwordChanged': 'Passwort erfolgreich geändert!',
  'settings.passwordError': 'Fehler beim Ändern des Passworts',
  'settings.language': 'Sprache',
  'settings.requiredFields': 'Alle Felder müssen ausgefüllt werden. Kostenstelle, Werk und Einkäuferorganisation dürfen nicht leer sein.',
  'settings.saveError': 'Fehler beim Speichern der Einstellungen',
  'settings.changeBtn': 'Ändern',
  'settings.placeholderSapUser': 'z.B. SAP123456',
  'settings.placeholderRequester': 'z.B. Max Mustermann',
  'settings.placeholderCostCenter': 'z.B. 110700',
  'settings.placeholderPlant': 'z.B. 1000',
  'settings.placeholderPurchasingOrg': 'z.B. 001',

  // ==================== APP.JS MESSAGES ====================
  'app.portalLoading': 'Portal wird geladen...',
  'app.unnamed': 'Unbenanntes Produkt',
  'app.addedToCart': '"{name}" wurde zum Warenkorb hinzugefügt!',
  'app.shopLoadError': 'Fehler beim Laden der Shop-Produkte',
  'app.shopSaved': 'Shop erfolgreich gespeichert!',
  'app.errorLoadingShopData': 'Fehler beim Laden der Shop-Daten. Bitte versuchen Sie es erneut.',
  'app.errorAddingToCart': 'Fehler beim Hinzufügen zum Warenkorb',
  'app.errorCreatingBanf': 'Fehler beim Erstellen der BANF-Anfrage',
  'app.errorSavingShop': 'Fehler beim Speichern des Shops',
  'app.errorDeletingShop': 'Fehler beim Löschen des Shops.',
  'app.unknownError': 'Unbekannter Fehler',
  'app.unknownSupplier': 'Unbekannter Anbieter',
  'app.internalShop': 'Interner Shop',

  // ==================== MODULE SCAFFOLD ====================
  'module.inDevelopment': 'Modul in Entwicklung',
  'module.inDevelopmentDesc': 'Dieses Modul befindet sich derzeit in der Entwicklung und wird in Kürze verfügbar sein.',

  // ==================== BENACHRICHTIGUNGS-GLOCKE ====================
  'notif.title': 'Benachrichtigungen',
  'notif.empty': 'Keine neuen Benachrichtigungen',
  'notif.approvals': 'BANFs warten auf Ihre Freigabe',
  'notif.decided': 'Ihre BANFs wurden entschieden',
  'notif.sapErrors': 'SAP-Übertragungen fehlgeschlagen',
  'notif.drafts': 'Offene Entwürfe',
  'notif.settingsTitle': 'Benachrichtigungs-Einstellungen',
  'notif.settingsHint': 'Die Schalter gelten nur für Sie und werden pro Benutzer gespeichert.',
  'notif.swApprovals': 'Wartende Freigaben',
  'notif.swDecided': 'Entscheidungen zu meinen BANFs',
  'notif.swSapErrors': 'SAP-Übertragungsfehler',
  'notif.swDrafts': 'Offene Entwürfe',
  'home.hiddenForUsers': 'Für Benutzer ausgeblendet',
};

export default core;
